export default __webpack_public_path__ + "static/Graphik-Bold-6417b640deb749d9e1ebbaa5d9d6709b.otf";